import { useId, useState } from 'react';
import FieldLabel from '../forms/FieldLabel';
import { eventLabel } from '../../lessons/model';

const searchable = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export default function EventPicker({ events, value, onChange, disabled = false, loading = false, label = 'Event' }) {
  const id = useId();
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const [active, setActive] = useState(0);
  const selected = events.find(event => event.id === value);
  const results = events.filter(event => searchable(eventLabel(event)).includes(searchable(query.trim())));
  const expanded = open && !disabled;
  const choose = event => { onChange(event.id); setOpen(false); setQuery(''); };
  function move(index) {
    const next = Math.max(0, Math.min(results.length - 1, index));
    setActive(next);
    document.getElementById(`${id}-option-${next}`)?.scrollIntoView?.({ block: 'nearest' });
  }
  return <div className="lesson-event-picker" onBlur={event => {
    if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false);
  }}>
    <FieldLabel htmlFor={id} required>{label}</FieldLabel>
    <input id={id} name="event_search" role="combobox" type="text" autoComplete="off" required
      disabled={disabled} value={expanded ? query : selected ? eventLabel(selected) : query}
      placeholder={loading ? 'Loading events…' : 'Search by event, city, or month'}
      aria-autocomplete="list" aria-expanded={expanded} aria-controls={`${id}-list`}
      aria-activedescendant={expanded && results[active] ? `${id}-option-${active}` : undefined}
      aria-describedby={`${id}-help`}
      onFocus={() => { if (!open) { setOpen(true); setQuery(''); setActive(0); } }}
      onClick={() => { if (!open) { setOpen(true); setQuery(''); setActive(0); } }}
      onChange={event => { setQuery(event.target.value); setOpen(true); setActive(0); onChange(''); }}
      onKeyDown={event => {
        if (event.key === 'Escape' && expanded) { event.preventDefault(); event.stopPropagation(); setOpen(false); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault(); setOpen(true);
          move(!expanded ? 0 : active + (event.key === 'ArrowDown' ? 1 : -1));
        }
        if (event.key === 'Enter' && expanded) {
          event.preventDefault();
          if (results[active]) choose(results[active]);
        }
      }} />
    <p className="lesson-hint" id={`${id}-help`}>{selected ? `Selected: ${eventLabel(selected)}` : 'Select an event from the results. You can also use the arrow keys and Enter.'}</p>
    {expanded && <div className="lesson-event-results">
      <ul id={`${id}-list`} role="listbox" aria-label="Matching events">
        {results.map((event, index) => <li key={event.id} id={`${id}-option-${index}`} role="option"
          aria-selected={value === event.id} className={index === active ? 'is-active' : ''}
          onMouseDown={event => event.preventDefault()} onMouseMove={() => setActive(index)}
          onClick={() => choose(event)}>
          <strong>{event.name}</strong><span>{eventLabel(event).slice(event.name.length + 3)}</span>
        </li>)}
      </ul>
      <p className="lesson-event-result-count" role="status">{results.length ? `${results.length} matching event${results.length === 1 ? '' : 's'}` : 'No matching events. Try a different name, city, or month.'}</p>
    </div>}
  </div>;
}
